import { Link } from "react-router-dom";
import { Sparkle } from "@phosphor-icons/react";
import VisitorCounter from "@/components/site/VisitorCounter";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-abyss text-[#8A99AA] relative overflow-hidden border-t border-[#C6A87C]/15"
    >
      <div className="absolute inset-0 noise-overlay opacity-[0.12] pointer-events-none" />
      <div className="relative max-w-[1600px] mx-auto px-6 md:px-12 xl:px-24 pt-20 lg:pt-28 pb-16 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3">
            <span className="w-10 h-10 border border-[#C6A87C]/60 text-[#C6A87C] flex items-center justify-center">
              <Sparkle weight="fill" size={16} />
            </span>
            <div>
              <div className="font-serif text-2xl text-[#F5F4F0]">
                Gurukul <span className="gold">of Ramana</span>
              </div>
              <div className="label-overline mt-1">Patent and Trademark Services and IP Training</div>
            </div>
          </div>
          <p className="mt-6 max-w-md text-[#8A99AA] leading-relaxed font-light">
            A one-stop place to get Patent Analytics Projects, Patent Drafting,
            Patent Illustrations, IP Strategy, Patent Valuation, IP Agreements
            effectively done, and to learn impactful and job-oriented IP Courses.
          </p>
        </div>

        <div className="lg:col-span-3">
          <div className="label-overline mb-4">Programmes</div>
          <ul className="space-y-3 text-sm">
            {[
              ["patent-analytics", "Patent Analytics"],
              ["patent-drafting", "Patent Drafting"],
              ["trademark-search", "Trademark Search"],
              ["ip-strategy", "IP Strategy"],
              ["patent-valuation", "Patent Valuation"],
              ["technology-transfer", "Technology Transfer"],
              ["introduction-to-ip-law", "Introduction to IP Law"],
              ["indian-trademark-agent-exam", "Indian Trademark Agent Exam"],
              ["certified-patent-valuation-analyst", "CPVA Guide"],
              ["ip-commercialisation", "IP Commercialisation"],
            ].map(([slug, t]) => (
              <li key={slug}>
                <Link
                  to={`/courses/${slug}`}
                  data-testid={`footer-course-${slug}`}
                  className="text-[#F5F4F0]/70 hover:text-[#C6A87C] transition-colors duration-300"
                >
                  {t}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-2">
          <div className="label-overline mb-4">School</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/about" data-testid="footer-about" className="text-[#F5F4F0]/70 hover:text-[#C6A87C] transition-colors duration-300">About</Link></li>
            <li><Link to="/patent-services" data-testid="footer-patent-services" className="text-[#F5F4F0]/70 hover:text-[#C6A87C] transition-colors duration-300">Patent and Trademark Services</Link></li>
            <li><Link to="/ip-training" data-testid="footer-ip-training" className="text-[#F5F4F0]/70 hover:text-[#C6A87C] transition-colors duration-300">IP Training</Link></li>
            <li><Link to="/courses" data-testid="footer-all-courses" className="text-[#F5F4F0]/70 hover:text-[#C6A87C] transition-colors duration-300">All Courses</Link></li>
            <li><Link to="/blog" data-testid="footer-blog" className="text-[#F5F4F0]/70 hover:text-[#C6A87C] transition-colors duration-300">Insights</Link></li>
            <li><Link to="/contact" data-testid="footer-contact" className="text-[#F5F4F0]/70 hover:text-[#C6A87C] transition-colors duration-300">Contact</Link></li>
            <li><Link to="/enroll" data-testid="footer-enroll" className="text-[#F5F4F0]/70 hover:text-[#C6A87C] transition-colors duration-300">Enrol</Link></li>
          </ul>
        </div>

        <div className="lg:col-span-2">
          <div className="label-overline mb-4">Reach Us</div>
          <ul className="space-y-3 text-sm">
            <li>
              <span className="text-[#F5F4F0]/40">E-mail:</span>{" "}
              <a href="mailto:venkatvasu@hotmail.com" className="hover:text-[#C6A87C] break-all transition-colors duration-300">
                venkatvasu@hotmail.com
              </a>
            </li>
            <li>
              <span className="text-[#F5F4F0]/40">Tel.#:</span>{" "}
              <a href="tel:+919819998036" className="hover:text-[#C6A87C] transition-colors duration-300">
                +91-9819998036
              </a>
            </li>
            <li>
              <span className="text-[#F5F4F0]/40">LinkedIn:</span>{" "}
              <a
                href="https://www.linkedin.com/in/venkataramananmv"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#C6A87C] break-all transition-colors duration-300"
              >
                linkedin.com/in/venkataramananmv
              </a>
            </li>
            <li>Bangalore — India</li>
          </ul>
        </div>
      </div>

      <VisitorCounter />

      <div className="relative select-none pointer-events-none overflow-hidden" aria-hidden="true">
        <div className="font-serif text-center whitespace-nowrap leading-[0.85] text-[8vw] text-[#F5F4F0]/[0.05] translate-y-[16%]">
          GURUKUL OF RAMANA
        </div>
      </div>

      <div className="relative border-t border-[#C6A87C]/10">
        <div className="max-w-[1600px] mx-auto px-6 md:px-12 xl:px-24 py-6 flex flex-col md:flex-row justify-between gap-3 text-xs text-[#F5F4F0]/40">
          <span data-testid="footer-copyright">© {new Date().getFullYear()} Gurukul of Ramana. All rights reserved.</span>
          <div className="flex items-center gap-5">
            <Link to="/privacy" data-testid="footer-privacy" className="hover:text-[#C6A87C] transition-colors duration-300">
              Privacy Notice
            </Link>
            <span className="font-mono-tech">Crafted for IP scholars worldwide.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
